/* Copyright (c) 2017 Backpack Health LLC */


import { authorizedApiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';

const NoteApi = {
  create(profileId) {
    return authorizedApiRequest('post', `profiles/${profileId}/notes`);
  },
  flagged(profileId, noteId) {
    return authorizedApiRequest('put', `profiles/${profileId}/notes/${noteId}/flagged`);
  },
  getAll(profileId) {
    return authorizedApiRequest('get', `profiles/${profileId}/notes`);
  },
  get(profileId, noteId) {
    return authorizedApiRequest('get', `profiles/${profileId}/notes/${noteId}`);
  },
  update(profileId, noteId) {
    return authorizedApiRequest('put', `profiles/${profileId}/notes/${noteId}`);
  },
  del(profileId, noteId) {
    return authorizedApiRequest('delete', `profiles/${profileId}/notes/${noteId}`);
  },
};

const NoteService = {

  create(profileId, noteData, callback) {
    return NoteApi.create(profileId)
      .send(noteData)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  flagged(profileId, noteId, isFlagged, callback) {
    return NoteApi.flagged(profileId, noteId)
      .send({
        flagged: isFlagged,
      })
      .end((err) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, null);
      });
  },

  getAll(profileId, callback) {
    return NoteApi.getAll(profileId)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        const noteCollection = apiError ? [] : res.body.data;
        callback(apiError, noteCollection);
      });
  },

  get(profileId, noteId, callback) {
    return NoteApi.get(profileId, noteId)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  update(profileId, noteData, callback) {
    return NoteApi.update(profileId, noteData.id)
      .send(noteData)
      .end((err) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, null);
      });
  },

  del(profileId, noteId, callback) {
    return NoteApi.del(profileId, noteId)
      .end((err) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, null);
      });
  },

};

export default NoteService;
